import React from "react";

function LegalDocumentsIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="10 10 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5 28.885L21.5575 26.9425L20.5 28L23.5 31L29.5 25L28.4425 23.9425L23.5 28.885ZM13.75 21.25H19V22.75H13.75V21.25ZM13.75 17.5H22.75V19H13.75V17.5ZM13.75 13.75H22.75V15.25H13.75V13.75Z"
        fill="#667085"
      />
      <path
        d="M19 31H11.5C10.6727 31 10 30.3272 10 29.5V11.5C10 10.6727 10.6727 10 11.5 10H25C25.8273 10 26.5 10.6727 26.5 11.5V22.75H25V11.5H11.5V29.5H19V31Z"
        fill="#667085"
      />
    </svg>
  );
}

export default LegalDocumentsIcon;
